

import { useAppStore } from 'kfone-frontend-core';
import translationDE from './de/translation.json';
import translationENUS from './en-US/translation.json';
import { DEFAULT_LANGUAGE_CODE } from 'constants/common.constants';
var appLanguageResources: any = {};

// customization of translation code
const getTranslationURL = (locale: string) => {
  let url = `${window.location.origin}/app/pequity/languages/${locale}.json`;
  url = url.replace(
    /home.kornferrytalent/g,
    'translations.kornferrytalent',
  );
  // for DR translation
  url = url.replace(
    /home-usw2.kornferrytalent-qa/g,
    'translations.kornferrytalent',
  );
  return url;
};

const fetchTranslations = async (locale: string) => {
  const translationURL = getTranslationURL(locale);
  const response = await fetch(translationURL);
  if (!response.ok) {
    throw new Error(`Failed to fetch translation: ${response.status}`);
  }
  return (await response.json()) as Record<string, any>;
};

export const getLanguages = async (languageCode?: string | null): Promise<any> => {
  try {
    // ✅ Normalize language format if cookie uses underscore
    const currentLanguage = useAppStore.getState().primaryLanguage?.value;
    let langCode =
      languageCode != null ? languageCode : (currentLanguage ?? DEFAULT_LANGUAGE_CODE);
    langCode = langCode.replace(/_/g, '-');
    sessionStorage.setItem('kf1-current-language', langCode);
    const shortLangCode = getShortLocale(langCode);
    // Wait for BOTH English + selected language, 
    const [enTranslations, selectedTranslations] = await Promise.all([
      fetchTranslations(DEFAULT_LANGUAGE_CODE),
      shortLangCode === DEFAULT_LANGUAGE_CODE ? Promise.resolve({}) : fetchTranslations(shortLangCode),
    ]);
    const translations = { ...enTranslations, ...selectedTranslations };

    return {
      en: { translation: translations },
      de: { translation: translations },
    };
  } catch (error) {
    console.error('Error fetching translation:', error);
    return {
      en: { translation: translationENUS },
      de: { translation: translationDE },
    };
  }
};

const LOCALE_OVERRIDES: Record<string, string> = {
  'en-US': DEFAULT_LANGUAGE_CODE,
  'pt-PT': 'pt',
  'es-XL': 'es-AR',
  'fr-FR': 'fr',
  'no-NO': 'no-NO',
};

const KEEP_FULL_PREFIXES = ['pt', 'fr', 'es', 'en-'];

export const getShortLocale = (locale: string): string => {
  try {
    const override = LOCALE_OVERRIDES[locale];
    if (override !== undefined) return override;
    if (KEEP_FULL_PREFIXES.some((prefix) => locale.startsWith(prefix))) return locale;
    return locale.slice(0, 2).toLowerCase();
  } catch (error) {
    console.error('Error getting short locale:', error);
    return DEFAULT_LANGUAGE_CODE;
  }
};

appLanguageResources = await getLanguages();

// const appLanguageResources: any =  { // no allowing en-us so marked any
//   'en-US': { translation: translationENUS },
//   de: { translation: translationDE },
// };

export default appLanguageResources;
